const getVideoFromRef = (ref: string) => groq`*[_id=="${ref}"][0]{
  ...,
  "video": upload.asset->{url, mimeType},
}`;

export default getVideoFromRef;
